import React, { useRef, useState } from "react";
import Checkbox from "../../../../common/components/Forms/Checkbox/Checkbox";
import cx from "classnames";
import { IQuoteClient } from "../../../interfaces/form/IQuoteClient";
import FamilySettingModal from "../../Modals/FamilySettingsModal/FamilySettingsModal";
import Icon from "../../../../common/components/Icon/Icon";
import styles from "./ClientSettingsBox.module.scss";
import { useHistory } from "react-router-dom";

export interface IClientSettingsBoxProduct {
    className?: string;
    client: IQuoteClient;
    name: string;
    setClient: (client: IQuoteClient) => void;
}

interface IClientSettingsBox {
    className?: string;
    subtitle?: string;
    title: string;
    id?: string;
}

interface IClientSettingsBoxIsSelectableEnabled extends IClientSettingsBox {
    isSelectable: true;
    onSelect: (isSelected: boolean) => void;
    isSelected: boolean;
    name: string;
}

interface IClientSettingsBoxIsSelectableDisabled extends IClientSettingsBox {
    isSelectable?: false;
}

type IClientSettingsBoxIsSelectable =
    | IClientSettingsBoxIsSelectableEnabled
    | IClientSettingsBoxIsSelectableDisabled;

interface IClientSettingsBoxIsOpenableEnabled extends IClientSettingsBox {
    isOpenable: true;
    isOpen: boolean;
    onOpen: () => void;
}

interface IClientSettingsBoxIsOpenableDisabled extends IClientSettingsBox {
    isOpenable?: false;
}

type IClientSettingsBoxIsOpenable =
    | IClientSettingsBoxIsOpenableEnabled
    | IClientSettingsBoxIsOpenableDisabled;

type ClientSettingsBoxType = IClientSettingsBoxIsSelectable &
    IClientSettingsBoxIsOpenable;

const ClientSettingsBox: React.FC<ClientSettingsBoxType> = (props) => {
    const { title, subtitle, children, id, className } = props;
    const [isOpenFamilySettingsModal, setIsOpenFamilySettingsModal] = useState(false);

    const contentRef = useRef<HTMLDivElement>();
    const history = useHistory();

    function getContentHeight(): number {
        if (!contentRef) return undefined;
        if (props.isOpenable && !props.isOpen) return undefined;

        return contentRef?.current?.scrollHeight || undefined;
    }

    return (
        <React.Fragment>
            <FamilySettingModal
                isOpen={isOpenFamilySettingsModal}
                onClose={() => setIsOpenFamilySettingsModal(false)}
            />
            <div
                id={id}
                className={cx({
                    [className]: !!className
                })}>
                <div
                    className={cx(
                        "layout-flex-row--justify-spaced",
                        "layout-flex-row--centered",
                        {
                            ["cursor-pointer"]: props.isOpenable
                        }
                    )}
                    onClick={props.isOpenable ? () => props.onOpen() : undefined}>
                    <h4
                        className={cx(
                            "text-font-size-ml",
                            "text-primary",
                            "text-bold",
                            "gap-none",
                            {
                                // ["fade-light"]:
                                //     props.isOpenable &&
                                //     !props.isOpen &&
                                //     props.isSelectable &&
                                //     !props.isSelected
                            }
                        )}>
                        {title}
                    </h4>
                    {props.isOpenable && (
                        <Icon
                            id="ChevronBack"
                            className={cx(styles["icon"], {
                                [styles["is-open"]]: props.isOpenable && props.isOpen
                            })}
                        />
                    )}
                </div>

                <div
                    ref={contentRef}
                    style={{
                        maxHeight: props.isOpenable && getContentHeight()
                    }}
                    className={cx(styles["content"], {
                        [styles["height-transition"]]: props.isOpenable,
                        [styles["is-closed"]]: props.isOpenable && !props.isOpen
                    })}>
                    {subtitle && (
                        <div
                            className={cx(
                                "layout-flex-row",
                                "text-font-size-s",
                                "gap-m"
                            )}>
                            {props.isSelectable && (
                                <React.Fragment>
                                    <Checkbox
                                        name={props.name}
                                        className="space-m"
                                        size="l"
                                        checked={!!props.isSelected}
                                        onChange={(e) => props.onSelect(e.target.checked)}
                                    />
                                    <a
                                        className="space-s"
                                        onClick={() => {
                                            if (props.isOpenable && !props.isSelected) {
                                                props.onOpen();
                                            }
                                            props.onSelect(!props.isSelected);
                                        }}>
                                        Include
                                    </a>
                                </React.Fragment>
                            )}
                            <span className="font-text-size-xs">
                                {`(${subtitle}`}
                                <a
                                    tabIndex={0}
                                    className="space-pre-s"
                                    onClick={() => {
                                        const paramBuilder = new URLSearchParams({
                                            edit: "true"
                                        });

                                        const search = new URLSearchParams(
                                            location.search
                                        );

                                        search.getAll("product").forEach((s) => {
                                            paramBuilder.append("product", s);
                                        });

                                        history.push(
                                            `/family?${paramBuilder.toString()}`
                                        );
                                    }}>
                                    Edit
                                </a>
                                )
                            </span>
                        </div>
                    )}
                    <div
                        className={cx({
                            ["fade-light"]: props.isSelectable && !props.isSelected
                        })}>
                        {children}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ClientSettingsBox;
